import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Kasutustingimused from "../pages/kasutustingimused/page";
import Privaatsuspoliitika from "../pages/privaatsuspoliitika/page";
import KupistePoliitika from "../pages/kupsiste-poliitika/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kasutustingimused",
    element: <Kasutustingimused />,
  },
  {
    path: "/privaatsuspoliitika",
    element: <Privaatsuspoliitika />,
  },
  {
    path: "/kupsiste-poliitika",
    element: <KupistePoliitika />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
